var React = require('react');

function Sotiyo (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:none;stroke:#000;stroke-linecap:square;stroke-linejoin:bevel;stroke-width:2px;}")),React.createElement("title",{"key":1},"Sotiyo"),React.createElement("g",{"id":"g1473","key":2},[React.createElement("path",{"id":"path1650","className":"cls-1","d":"M14,93.17h8.33V84.83h83.34v8.34H114V34.83h-8.33v8.34H22.33V34.83H14Z","key":0}),React.createElement("path",{"id":"path1652","className":"cls-1","d":"M47.33,43.17v-25","key":1}),React.createElement("path",{"id":"path1652-6","className":"cls-1","d":"M80.67,43.17v-25","key":2}),React.createElement("path",{"id":"path1652-2","className":"cls-1","d":"M80.67,109.83v-25","key":3}),React.createElement("path",{"id":"path1652-0","className":"cls-1","d":"M47.33,109.83v-25","key":4})])]);
}

Sotiyo.defaultProps = {"id":"svg8","viewBox":"0 0 128 128"};

module.exports = Sotiyo;

Sotiyo.default = Sotiyo;
